export default "__VITE_ASSET__bIMY0YQC__"